<template>
	<section
		id="build-it-section"
		class="wip-build-it"
		:style="`background-image: url('${ buildItYourself.background }')`"
	>
		<div class="container">
			<div class="row">
				<div class="col-md-4">
					<h3 class="wip-build-it__heading">
						{{ buildItYourself.heading | stripTags }}
					</h3>
					<div class="wip-build-it__text" v-html="buildItYourself.body" />
					<div class="wip-build-it__build-your-own-img">
						<img :src="buildItYourself.image" alt="BLD builds">
					</div>
					<div class="wip-build-it__build-your-own">
						<h4 class="hide-mobile wip-build-it__build-your-own__subheading">
							{{ buildYourOwn.subheading | stripTags }}
						</h4>
						<div class="hide-mobile wip-build-it__text" v-html="buildYourOwn.body" />
						<router-link class="wip-build-it__button btn" :to="String(buildYourOwn.buttonUrl)">
							{{ buildYourOwn.buttonText }}
						</router-link>
					</div>
				</div>
				<div class="col-md-8">
					<div class="wip-build-it__prebuilds">
						<h3 class="wip-build-it__heading mt-4-mobile">
							{{ whereToStart.heading | stripTags }}
						</h3>
						<div class="wip-build-it__text" v-html="whereToStart.body" />
						<div class="container-fluid">
							<div class="row">
								<div v-for="build in prebuilds" class="col-md-3" :key="build.id">
									<div class="wip-build-it__prebuild">
										<div class="wip-build-it__prebuild__img">
											<img :src="build.logo_url" :alt="build.title">
										</div>
										<h4 class="wip-build-it__build-your-own__subheading">
											{{ build.title | stripTags }}
										</h4>
										<div class="wip-build-it__text" v-html="build.body" />
										<router-link
											class="wip-build-it__button btn"
											:to="String(build.landing_page_buttons[0].url)"
										>
											{{ build.landing_page_buttons[0].text }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "BuildItYourself",
	props: {
		buildItData: {
			type: Array,
			required: true
		}
	},
	computed: {
		buildItYourself() {
			if (!this.buildItData.length) {
				return {};
			}

			return {
				heading: this.buildItData[0].title,
				body: this.buildItData[0].body,
				image: this.buildItData[0].logo_url,
				background: this.buildItData[0].background_url
			};
		},
		buildYourOwn() {
			if (!this.buildItData.length) {
				return {};
			}

			return {
				subheading: this.buildItData[1].title,
				body: this.buildItData[1].body,
				buttonText: this.buildItData[1].landing_page_buttons[0].text,
				buttonUrl: this.buildItData[1].landing_page_buttons[0].url
			};
		},
		whereToStart() {
			if (!this.buildItData.length) {
				return {};
			}

			return {
				heading: this.buildItData[2].title,
				body: this.buildItData[2].body
			};
		},
		prebuilds() {
			return this.buildItData.length ? this.buildItData.slice(3) : [];
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.wip-build-it {
    padding: 75px 0;
    color: $white;
    background-size: cover;

    @media (max-width: 991px) {
        padding: 45px 0;
    }

    .container {
        > .row {
            @media (min-width: 1200px) {
                margin-left: 35px;
            }
        }

        @media (min-width: 580px) and (max-width: 991px) {
            padding: 0 100px;
        }
    }

    &__heading {
        font-size: 32px;
        text-transform: uppercase;
        margin: 0;

        @media (max-width: 991px) {
            text-align: center;
            font-size: 24px;
        }
    }

    &__text {
        margin-bottom: 10px;
        max-width: 460px;

        @media (max-width: 991px) {
            text-align: center;
            margin: 0 auto;
        }
    }

    &__build-your-own-img {
        max-width: 330px;
        margin-bottom: 35px;
        margin-top: 30px;

        @media (max-width: 991px) {
            margin: 30px auto;
        }

        img {
            width: 100%
        }
    }

    &__button {
        background: $oldpurple;
        color: $white;
        padding: 12px 24px;
        transition: all .2s;

        &:hover {
            background: $white;
            color: $oldpurple;
        }

        @media (max-width: 991px) {
            width: 100%;
        }
    }

    &__build-your-own__subheading {
        font-size: 16px;
        letter-spacing: 1.43px;
        margin-top: 0;
        text-transform: uppercase;
        margin-bottom: 3px;

        @media (max-width: 991px) {
            text-align: center;
        }
    }

    &__prebuilds {
        padding-left: 100px;

        @media (min-width: 991px) and (max-width: 1200px) {
            padding-left: 60px;
        }

        @media (max-width: 991px) {
            padding-left: 0;
        }

        .col-md-3 {
            padding: 0;
            margin-right: 40px;

            @media (max-width: 991px) {
                margin-right: 0;
            }
        }
    }

    &__prebuild {
        &__img {
            height: 225px;
            display: flex;
            align-items: center;
            margin-top: 30px;

            @media (min-width: 1200px) {
                margin-bottom: 40px;
            }

            @media (min-width: 991px) and (max-width: 1200px) {
                margin-bottom: 15px;
            }

            @media (max-width: 991px) {
                margin-bottom: 0;
                width: 160px;
                height: 160px;
                margin-left: auto;
                margin-right: auto;
            }

            img {
                width: 100%;
            }
        }
    }

    @media (max-width: 991px) {
        .hide-mobile {
            display: none;
        }

        .mt-4-mobile {
            margin-top: 40px;
        }
    }
}
</style>